export { default } from "./StreamColorSelector";
